export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`);
  if (element) {
    return element.getAttribute("content");
  }
}
//Events - TODO consolidate these to one function? 
export function emitFileUploadStarted(id){
  parent.postMessage(
  {
    event: 'fileUploadStarted',
    widgetId: id,
  },"*");
}

export function emitFileUploadFailed(id, file, error){
  parent.postMessage(
  {
    event: 'fileUploadFailed',
    widgetId: id,
    file: file, 
    error: error
  },"*");
}

export function emitOpenWidget(id) {
  parent.postMessage(
  {
    event: 'openWidget',
    widgetId: id
  },"*");
}

export function emitCloseWidget(id, number) {
  parent.postMessage(
  {
    event: 'closeWidget',
    widgetId: id, 
    numberOfFiles: number
  },"*");
}

export function sendDataToParent(files, id, url, close) {
  // TODO update React component to also emit file object
  parent.postMessage(
    {
      event: "fileUploadSuccess",
      files: files,
      widgetId: id,
      uploadResult: 'success',
      url: url,
      close: close
    },
    "*");
}
// End events
export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

export function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (Array.from) {
    return Array.from(value);
  } else {
    return [].slice.call(value);
  }
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}
